import { render } from "./Roles.vue?vue&type=template&id=7a6439a1"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/mobysuite-docs-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__